import EditableTextField from 'components/forms/inputs/EditableTextField';
import Unmasked from 'components/Unmasked';
import React from 'react';
import { useUpdateMatterCaseNumberMutation } from 'store/api/matters';
import { useHasPermissions } from 'utils/permissionUtil';

interface EditableMatterCaseNumberProps {
    matterId: number;
    caseNumber: string | undefined | null;
}

const EditableMatterCaseNumber: React.FC<EditableMatterCaseNumberProps> = ({ matterId, caseNumber }) => {
    const [updateMatterCaseNumber] = useUpdateMatterCaseNumberMutation();
    const hasPermission = useHasPermissions(['UPDATE.MATTERS.CASE_NUMBER']);

    const handleSave = async (newValue: string) => {
        await updateMatterCaseNumber({
            id: matterId,
            value: newValue,
        }).unwrap();
    };

    return (
        <Unmasked as="div">
            <EditableTextField placeholder={'-'} value={caseNumber} onSave={handleSave} isEditEnabled={hasPermission} />
        </Unmasked>
    );
};

export default EditableMatterCaseNumber;
